
import { ReceptionCommentDispInfo } from "../../../../../domain/workflow/reference";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { CommonTabMixin } from ".";
import { ReceptionCommentSet, ReceptionManager } from "../../../../../domain/workflow/reception";
import { ButtonInfo } from "../../../../../domain/workflow/items";

import WorkflowActionDialog from "../../../dialogs/WorkflowActionDialog.vue";
import WorkflowActionConfirmDialog from "../../../dialogs/WorkflowActionConfirmDialog.vue";
import { ReceptionCommentUnitKinds, ReceptionCommentSortItemKinds } from "../../../../../domain/workflow/kinds";
import { IMultiOrderableUserListSelectorDialogCondition } from "../../../../user/dialogs";
import { IConfiguration } from "../../../../../domain/configuration";
import { User } from "../../../../../domain/user";
import Enumerable from "linq";
import { DomainRegistry } from "../../../../../domain";

@Component({
})
export default class DocumentTabMixin extends Mixins(CommonTabMixin) {
  
  @Prop()
  commentSetting: ReceptionCommentDispInfo;

  @Prop()
  workflowActionDialog: WorkflowActionDialog;

  @Prop()
  workflowActionConfirmDialog: WorkflowActionConfirmDialog;

  // 伝達事項
  get nextMessagePermission(): ButtonInfo {
    return this.permissions ? this.permissions.nextMessage : null;
  }

  get permittedNextMessage(): boolean {
    return this.nextMessagePermission ? this.nextMessagePermission.isPermitted : false;
  }

  get nextMessageCommentId(): number {
    if (!this.detail) { return null; }
    return ((this.nextMessageUnitKind === ReceptionCommentUnitKinds.Single) && this.detail.commentSet.nextMessages[0])
      ? this.detail.commentSet.nextMessages[0].id
      : null;
  }

  get nextMessageArchiveId(): number {
    if (!this.detail) { return null; }
    return ((this.nextMessageUnitKind === ReceptionCommentUnitKinds.Single) && this.detail.commentSet.nextMessages[0])
      ? this.detail.commentSet.nextMessages[0].archiveId 
      : null;
  }

  get nextMessage(): string {
    if (!this.detail) { return null; }
    return ((this.nextMessageUnitKind === ReceptionCommentUnitKinds.Single) && this.detail.commentSet.nextMessages[0])
      ? this.detail.commentSet.nextMessages[0].content 
      : null;
  }

  get commentSet(): ReceptionCommentSet {
    return this.detail
      ? this.detail.commentSet
      : null;
  }

  get commentUnitKind(): ReceptionCommentUnitKinds {
    return this.commentSetting ? this.commentSetting.commentMode : ReceptionCommentUnitKinds.Multiple;
  }

  // 伝達事項の管理単位
  get nextMessageUnitKind(): ReceptionCommentUnitKinds {
    return this.commentSetting ? this.commentSetting.nextMessageMode : ReceptionCommentUnitKinds.Single;
  }

  get commentDefaultSortType(): ReceptionCommentSortItemKinds {
    return this.commentSetting ? this.commentSetting.commentDefaultSortType : ReceptionCommentSortItemKinds.UpdateDateTime;
  }

  get shouldSortCommentAsc(): boolean {
    return this.commentSetting && this.commentSetting.shouldSortCommentAsc;
  }

  // 差戻しコメント
  get backMessagePermission(): ButtonInfo {
    return this.permissions ? this.permissions.backMessage : null;
  }

  get permittedBackMessage(): boolean {
    return this.backMessagePermission ? this.backMessagePermission.isPermitted : false;
  }

  // --------------文書用ボタン------------------------

  get showDocumentPermission(): ButtonInfo {
    return this.permissions ? this.permissions.documentShow : null;
  }

  get permittedShowDocument(): boolean {
    return this.showDocumentPermission ? this.showDocumentPermission.isPermitted : false;
  }

  get createDocumentPermission(): ButtonInfo {
    return this.permissions ? this.permissions.documentCreate : null;
  }

  get permittedCreateDocument(): boolean {
    return this.createDocumentPermission ? this.createDocumentPermission.isPermitted : false;
  }

  get quoteDocumentPermission(): ButtonInfo {
    return this.permissions ? this.permissions.documentQuote : null;
  }

  get permittedQuoteDocument(): boolean {
    return this.quoteDocumentPermission ? this.quoteDocumentPermission.isPermitted : false;
  }

  get editDocumentPermission(): ButtonInfo {
    return this.permissions ? this.permissions.documentEdit : null;
  }

  get permittedEditDocument(): boolean {
    return this.editDocumentPermission ? this.editDocumentPermission.isPermitted : false;
  }

  get approvePermission(): ButtonInfo {
    return this.permissions ? this.permissions.approve : null;
  }

  get permittedApprove(): boolean {
    return this.approvePermission ? this.approvePermission.isPermitted : false;
  }

  get sendBackPermission(): ButtonInfo {
    return this.permissions ? this.permissions.sendBack : null;
  }

  get permittedSendBack(): boolean {
    return this.sendBackPermission ? this.sendBackPermission.isPermitted : false;
  }

  get sendBackAndEditPermission(): ButtonInfo {
    return this.permissions ? this.permissions.sendBackAndEdit : null;
  }

  get permittedSendBackAndEdit(): boolean {
    return this.sendBackAndEditPermission ? this.sendBackAndEditPermission.isPermitted : false;
  }

  get publishPermission(): ButtonInfo {
    return this.permissions ? this.permissions.publish : null;
  }

  get permittedPublish(): boolean {
    return this.publishPermission ? this.publishPermission.isPermitted : false;
  }

  get finishPermission(): ButtonInfo {
    return this.permissions ? this.permissions.finish : null;
  }

  get permittedFinish(): boolean {
    return this.finishPermission ? this.finishPermission.isPermitted : false;
  }

  get cancelFinishPermission(): ButtonInfo {
    return this.permissions ? this.permissions.cancelFinish : null;
  }

  get permittedCancelFinish(): boolean {
    return this.cancelFinishPermission ? this.cancelFinishPermission.isPermitted : false;
  }

  get finishWithoutCostPermission(): ButtonInfo {
    return this.permissions ? this.permissions.finishWithoutCost : null;
  }

  get permittedFinishWithoutCost(): boolean {
    return this.finishWithoutCostPermission ? this.finishWithoutCostPermission.isPermitted : false;
  }

  get permittedRequestAnother(): boolean {
    return this.requestAnotherPermission ? this.requestAnotherPermission.isPermitted : false;
  }

  get requestAnotherPermission(): ButtonInfo {
    return this.permissions ? this.permissions.requestAnother : null;
  }
  
  get hasDocumentReferenceFiles(): boolean {
    return this.documentReferenceFiles && this.documentReferenceFiles.length > 0;
  }

  get permittedShowDocumentReferenceFiles(): boolean {
    return this.permittedCreateDocument || this.permittedQuoteDocument || this.permittedEditDocument;
  }

  // --------------プロパティ-------------------------------

  get formatPreviewSource(): string {
    if (this.detail) {
      if (this.detail.format && this.detail.format.previewSource) {
        return this.detail.format.previewSource.source;
      }
    }

    return "";
  }

  // 閲覧・記載制限がかかるようになる
  // 閲覧権限がない場合はプレビュー出さない
  get documentPreviewSource(): string {
    if (this.document && this.documentReadable) {
        if (this.document.previewSource) {
          return this.document.previewSource.source;
        }
    }

    return "";
  }

  get requestAnotherCondition(): IMultiOrderableUserListSelectorDialogCondition {
    return {
      departmentId: this.detail.department.id,
      isMultiSelectable: null,
      name: null,
      defaultSelectedProfessionCodes: this.defaultProfessions ? this.defaultProfessions : null,
      isMultiSingleSwitchable: true,
    };
  }

  get defaultProfessions(): string[] {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.user.finder.doctorProfessionCodes;
  }

  // ---------------メソッド--------------------------------------

  updateManagers(managers: User[], title: string): void {
    this.startLoading();
    const newManagers = Enumerable.from(managers).select((u, index) => new ReceptionManager((index + 1), u)).toArray();
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    repository.registerManagers(this.detail.id, newManagers)
      .then((result) => {
        this.stopLoading();
        if (result.success) {
          this.$success(title, "処理が完了しました。");
          // 親に更新通知
          this.wfaction();
        } else {
          this.$error(result.message, result.reason);
        }
      })
      .catch(e => {
        this.stopLoading();
        this.showRequestErrorMessage("エラー", "処理の実行に失敗しました。", e);
      });
  }

}
